import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";
import {
  postGstrOneFilingSaveDataAction,
  postGstrOneFilingSendOTPAction,
  postGstrOneCompleteFilingAction,
  resetGstModuleError,
  resetGstFilingError,
  resetGstFilingSuccess,
  resetGstFilingMessage,
  gstOneProceedFileAction,
  postGstrOneFilingResetSaveDataAction,
  resetGstOtpVerifyMessage,
  resetGstOneFilingACKNumber,
  resetNumberOfInvoices,
  resetGstOneFilingStatus,
  gstOneFilingStatus,
  resetGstOneFilingStatusSuccess,
  resetGstOneFilingStatusError,
  resetGstOneFilingStatusStatusCode,
  resetGstOneFilingStatusMessage,
} from "../../../redux/gstModule";
import {
  PostGstrOneSaveDataType,
  GstrFilingSendOTPPayload,
  PostGstrOneCompleteFilingType,
  PostGstrOneProceedType,
  GstrOneSatusType,
  GstrOneFilingStatusDataType,
  GstrOneDownloadJsonType,
} from "../../../commonTypes/gstTypes";
import { OptionsType } from "../../../commonTypes/universalTypes";
import { getMonthNumber } from "../../../utils/commonFunctions";
import {
  CollapseClose,
  CollapseOpen,
  NewDownloadIconActive,
  RedErrorIcon,
  SuccessFill,
  WarningIcon,
} from "../../../assets/images";
import "./GstOneFiling.scss";
import { Progress } from "reactstrap";
import { GstrOneAutoFilledTable } from "../../../components/Gst";
import { ErrorSuccessModal, Loader } from "../../../components/commons";
import { resetSession } from "../../../redux/auth";
import ValidateGST from "../../../components/commons/ValidateGST/ValidateGST";
import { Link } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { gstrOneDownloadJsonApi } from "../../../apis/gstModuleApis";
import toast from "react-hot-toast";
import FileSaver from "file-saver";
type AppProps = {
  history: any;
  dispatchGstrOneDataSave: (data: PostGstrOneSaveDataType) => void;
  token: string | null;
  success: number | null;
  gstFilingSuccess: number | null;
  error: any;
  gstError: any;
  statusCode: number | null;
  fetching: boolean;
  message: string | null;
  clientCode: number | string;
  financialYear: OptionsType;
  month: OptionsType;
  dispatchGstrOneFilingSendOTP: (data: GstrFilingSendOTPPayload) => void;
  dispatchResetGstFilingError: () => void;
  dispatchResetGstFilingSuccess: () => void;
  dispatchGstrOneComleteFiling: (data: PostGstrOneCompleteFilingType) => void;
  dispatchResetSession: () => void;
  dispatchResetGstModuleError: () => void;
  dispatchResetGstFilingMessage: () => void;
  // dispatchGstOneProceedFile: (data: PostGstrOneSaveData) => void;
  gstFetching: boolean;
  gstFilingFetching: boolean;
  gstOtpVerifyMessage: null | string;
  dispatchGstOneProceedFileAction: (data: PostGstrOneProceedType) => void;
  dispatchGstrOneResetDataSave: (data: PostGstrOneSaveDataType) => void;
  dispatchResetGstOtpVerifyMessage: () => void;
  dispatchResetGstOneFilingACKNumber: () => void;
  dispatchResetNumberOfInvoices: () => void;
  gstOneFilingACKNumber: null | string;
  numberOfInvoices: number;
  numberOfUploadInvoices: number;
  numberOfEInvoices: number;
  dispatchResetGstOneFilingStatus: () => void;
  dispatchResetGstOneFilingStatusSuccess: () => void;
  dispatchResetGstOneFilingStatusError: () => void;
  dispatchResetGstOneFilingStatusStatusCode: () => void;
  dispatchResetGstOneFilingStatusMessage: () => void;
  dispatchGstOneFilingStatus: (data: GstrOneSatusType) => void;
  gstOneFilingStatus: GstrOneFilingStatusDataType | any;
};

const GstOneFiling = ({
  dispatchGstrOneDataSave,
  token,
  success,
  error,
  statusCode,
  fetching,
  message,
  dispatchGstrOneFilingSendOTP,
  dispatchResetGstFilingError,
  dispatchResetGstFilingSuccess,
  gstFilingSuccess,
  dispatchGstrOneComleteFiling,
  history,
  dispatchResetSession,
  dispatchResetGstModuleError,
  dispatchResetGstFilingMessage,
  dispatchGstOneProceedFileAction,
  gstFetching,
  gstError,
  gstFilingFetching,
  gstOtpVerifyMessage,
  dispatchGstrOneResetDataSave,
  dispatchResetGstOtpVerifyMessage,
  dispatchResetGstOneFilingACKNumber,
  gstOneFilingACKNumber,
  dispatchResetNumberOfInvoices,
  numberOfInvoices,
  numberOfUploadInvoices,
  numberOfEInvoices,
  dispatchResetGstOneFilingStatus,
  dispatchResetGstOneFilingStatusSuccess,
  dispatchResetGstOneFilingStatusError,
  dispatchResetGstOneFilingStatusStatusCode,
  dispatchResetGstOneFilingStatusMessage,
  dispatchGstOneFilingStatus,
  gstOneFilingStatus,
}: AppProps) => {
  const clientCode = history?.location?.state?.clientCode;
  const gstin = history?.location?.state?.gstin;
  const gstDetails = history?.location?.state?.gstNo;
  const financialYear = history?.location?.state?.financialYear;
  const month = history?.location?.state?.month;
  const isNil = history?.location?.state?.isNil;
  const currentStatus = history?.location?.state?.status;
  const [isSummaryCollapsed, setIsSummaryCollapsed] = useState(false);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(1);
  const currentStateValue =
    gstOneFilingStatus?.gstr_1_filing_current_status ||
    currentStatus?.gstr_1_filing_current_status;

  const [progressValue, setProgressValue] = useState(
    currentStateValue == "save_success" ||
      currentStateValue === "proceed_file_failed" ||
      currentStateValue == "proceed_file_success_gstr1_summary_failed"
      ? 100
      : 0
  );
  const [step, setStep] = useState(
    currentStateValue == "file_gstr1_failed"
      ? 2
      : currentStateValue === "proceed_file_success_gstr1_summary_success"
      ? 2
      : currentStateValue === "file_gstr1_success"
      ? 4
      : isNil
      ? 2
      : 0
  );
  const [otp, setOtp] = useState("");
  let yearData = 20 + month?.value?.split("-")?.[1];
  useEffect(() => {
    dispatchResetGstFilingError();
    dispatchResetGstFilingMessage();
    dispatchResetGstFilingSuccess();
    dispatchResetGstOneFilingACKNumber();
    dispatchResetNumberOfInvoices();
    dispatchResetGstOneFilingStatus();
    dispatchResetGstOneFilingStatusSuccess();
    dispatchResetGstOneFilingStatusError();
    dispatchResetGstOneFilingStatusStatusCode();
    // dispatchResetGstOneFilingStatusMessage();
  }, []);
  useEffect(() => {
    if (
      isNil &&
      currentStateValue !== "proceed_file_success_gstr1_summary_success" &&
      currentStateValue !== "file_gstr1_failed" &&
      currentStateValue !== "file_gstr1_success"
    ) {
      handleProceedFiling();
    }
  }, [isNil]);
  useEffect(() => {
    if (
      step == 0 &&
      currentStateValue !== "save_success" &&
      currentStateValue !== "proceed_file_failed" &&
      currentStateValue !== "file_gstr1_failed" &&
      currentStateValue !== "proceed_file_success_gstr1_summary_failed"
    ) {
      let monthData = month?.value?.split("-")?.[0];
      let finalData = {
        token,
        client_code: clientCode,
        gst_number: gstin?.gstIn,
        year: yearData,
        month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
          getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
        }`,
      };
      dispatchGstrOneDataSave(finalData);
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (fetching && gstFilingSuccess === null) {
        if (progressValue > 70) {
          setProgressValue(89);
          return;
        } else if (progressValue < 100) {
          setProgressValue((prev) => prev + 10);
        }
      } else if (
        !fetching &&
        (gstFilingSuccess === 0 || gstFilingSuccess === 1)
      ) {
        setProgressValue(100);
      }
    }, 1000);

    return () => clearTimeout(interval);
  }, [fetching, gstFilingSuccess, progressValue]);

  useEffect(() => {
    if (gstOtpVerifyMessage === "OTP Verified Successfully!") {
      setTimeout(() => {
        dispatchResetGstOtpVerifyMessage();
        window?.location?.reload();
      }, 3000);
    }
  }, [gstOtpVerifyMessage]);

  useEffect(() => {
    if (message === "EVC OTP Request sent Successfully!") {
      let time: any = null;

      if (minutes >= 0) {
        time = setTimeout(() => {
          setSeconds(() => seconds - 1);
          if (seconds === 0) {
            setMinutes(minutes - 1);
            setSeconds(59);
          }
          if (minutes === 0 && seconds === 0) {
            setSeconds(0);
            setMinutes(0);
          }
        }, 1000);
      }
      return () => {
        clearTimeout(time);
      };
    }
  }, [message, minutes, seconds]);

  useEffect(() => {
    if (message && message?.length) {
      let monthData = month?.value?.split("-")?.[0];
      let finalData = {
        token,
        client_code: clientCode,
        gst_number: gstin?.gstIn,
        year: yearData,
        month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
          getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
        }`,
      };

      dispatchGstOneFilingStatus(finalData);
      if (message === "OTP for GSTR-1 verified successfully") {
        dispatchResetGstFilingError();
        dispatchResetGstFilingMessage();
        // setStep(3);
      }
    }
  }, [message]);

  useEffect(() => {
    if (message === "GSTR-1 Filed Succesfully!") {
      dispatchResetGstFilingError();
      dispatchResetGstFilingMessage();
      setStep(4);
    }
  }, [message]);

  const handleShowSummary = () => {
    setIsSummaryCollapsed(!isSummaryCollapsed);
  };

  const handleFileGstOtp = () => {
    setStep(3);
    handleSendOTP();
  };

  const handleSendOTP = () => {
    let monthData = month?.value?.split("-")?.[0];
    let finalData = {
      token,
      gst_number: gstin?.gstIn,
      client_code: clientCode,

      pan_number: gstDetails?.authorizedSignatoryPanNumber,
      gstr_type: "gstr-1",
    };
    dispatchGstrOneFilingSendOTP(finalData);
  };

  const handleFinalSubmit = () => {
    dispatchResetGstFilingError();
    dispatchResetGstFilingMessage();
    dispatchResetGstFilingSuccess();
    let monthData = month?.value?.split("-")?.[0];
    let finalData = {
      otp: otp,
      gst_number: gstin?.gstIn,
      client_code: clientCode,
      token,
      year: yearData,
      month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
        getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
      }`,
      pan_number: gstDetails?.authorizedSignatoryPanNumber,
    };
    dispatchGstrOneComleteFiling(finalData);
  };

  const handleErrorModal = () => {
    if (gstFilingSuccess === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
            }}
            statusCode={statusCode}
          />
        );
      }

      if (
        gstError &&
        gstError === "You're Not Authorized. Please contact admin!"
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!gstError}
            title="Error"
            message="You're Not Authorized. Please contact admin!"
            buttonText="OK"
            statusCode={statusCode}
            onPress={() => {
              dispatchResetGstFilingError();
              dispatchResetGstFilingSuccess();
              dispatchResetGstFilingMessage();
            }}
          />
        );
      }
      // else if (!!gstError && statusCode !== 401) {
      //   return (
      //     <ErrorSuccessModal
      //       type="error"
      //       isOpen={!!gstError}
      //       title="Error"
      //       message={gstError}
      //       buttonText="OK"
      //       onPress={() => {
      //here gst error reset
      //         dispatchResetGstFilingError();
      //         dispatchResetGstFilingSuccess();
      //         dispatchResetGstFilingMessage();
      //       }}
      //     />
      //   );
      // }
    } else if (
      message === "GSTR-1 Data reset Successfully Completed!" &&
      success === 1
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`GSTR-1 Data reset Successfully Completed!`}
          buttonText="OK"
          onPress={() => {
            history.push({
              pathname: `/gst/gstr-one/${clientCode}`,
            });
          }}
          statusCode={statusCode}
        />
      );
    } else if (message === "GST File Proceeded Successfully" && success === 1) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={success === 1}
          title="Success"
          message={`GST File Proceeded Successfully`}
          buttonText="OK"
          onPress={() => {
            history.push({
              pathname: `/gst/gstr-one/${clientCode}`,
            });
          }}
          statusCode={statusCode}
        />
      );
    }
    return false;
  };

  const ErrorDisplay = ({ item }: any) => {
    const errorKeys = item.error_cd + ": " + item.error_msg;

    return (
      <>
        <div>
          <div
            className="mt-3 text-left"
            style={{ fontSize: "15px", fontWeight: 600 }}
          >
            {item?.invoice_number
              ? `Invoice Number: ${item?.invoice_number}`
              : item?.invoice_type}
            <br></br>
            {item?.section ? `Section : ${item?.section?.toUpperCase()}` : ""}
            <br></br>
            {item?.hsn_sac_code ? `HSN SAC Code: ${item?.hsn_sac_code}` : ""}
          </div>
          <div
            style={{
              border: "1px solid #ba4916",
              backgroundColor: "#fef2ed",
              borderRadius: "6px",
              width: "fit-content",
            }}
            className="mt-2 mb-2 error-msg p-2"
          >
            <span className="mr-1">
              <img src={RedErrorIcon} alt="error" />
            </span>

            {errorKeys}
          </div>
        </div>
      </>
    );
  };

  const errorCounts =
    error && Array.isArray(error) && error?.length
      ? error?.map((invoice: any) => {
          return {
            invoice_number: invoice?.invoice_number,
            errorCount: Object.keys(invoice?.errors)?.length,
          };
        })
      : [];

  const totalErrorCount = errorCounts?.reduce(
    (acc, invoice) => acc + invoice?.errorCount,
    0
  );
  const handleProceedFiling = () => {
    dispatchResetGstFilingError();
    dispatchResetGstFilingMessage();
    dispatchResetGstFilingSuccess();
    let monthData = month?.value?.split("-")?.[0];
    let finalData = {
      token,
      client_code: clientCode,
      gst_number: gstin?.gstIn,
      year: yearData,
      month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
        getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
      }`,
      gstr_type: "gstr-1",
      is_nil: !isNil ? "N" : "Y",
      is_gst_summary_fetched:
        currentStateValue == "proceed_file_success_gstr1_summary_failed"
          ? 0
          : 1,
    };

    dispatchGstOneProceedFileAction(finalData);
  };
  const handleResetProceedFiling = () => {
    // dispatchResetGstFilingError();
    // dispatchResetGstFilingMessage();
    // dispatchResetGstFilingSuccess();
    let monthData = month?.value?.split("-")?.[0];
    let finalData = {
      token,
      client_code: clientCode,
      gst_number: gstin?.gstIn,
      year: yearData,
      month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
        getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
      }`,
    };
    dispatchGstrOneResetDataSave(finalData);
  };

  const handlePrepareDownload = () => {
    let monthData = month?.value?.split("-")?.[0];
    let params = {
      token,
      client_code: clientCode,
      gst_number: gstin?.gstIn,
      year: yearData,
      month: `${getMonthNumber(monthData) > 9 ? "" : "0"}${
        getMonthNumber(monthData) === 0 ? "" : getMonthNumber(monthData)
      }`,
    };

    if (params && token && clientCode) {
      handleDownload(params);
    }
  };

  const handleDownload = (params: GstrOneDownloadJsonType) => {
    let reportName = `${clientCode}_GSTR-1_JSON.json`;

    gstrOneDownloadJsonApi(params).then((response: any) => {
      const jsonData = JSON.stringify(response.data, null, 2); // Format with indentation
      const blob = new Blob([jsonData], {
        type: "application/json;charset=utf-8",
      });
      FileSaver.saveAs(blob, reportName);

      toast.success("JSON File Downloaded Successfully!", {
        duration: 3000,
      });
    });
  };

  function errorShow() {
    return (
      <>
        {Array.isArray(error?.errors) && error?.errors?.length ? (
          <>
            <div className="mt-4" style={{ fontSize: "18px", fontWeight: 500 }}>
              {/* Error Occurred in this GSTR-1 Form. Please resolve the following
              errors and try again. */}
              Error occurred in this process. Please, resolve the following
              errors and try again.
              <span className="text-decoration-underline pointer">
                <Link
                  to={`/gst/gstr-one/${clientCode}`}
                  className="go-back-link"
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  Go Back
                </Link>
              </span>
            </div>
            {/* {message !== "Error in uploading Invoice and Invoice Summary" ? (
              <div className="mt-3 mb-3" style={{ color: "#6e7491" }}>
                Total {totalErrorCount} errors found in {error?.length}{" "}
                Invoices. Please fix all errors to proceed with GSTR-1 Filing.
              </div>
            ) : (
              ""
            )} */}
          </>
        ) : (
          ""
        )}

        {error && Array.isArray(error?.errors) && error?.errors?.length ? (
          error?.errors?.map((item: any) => {
            return (
              <>
                <ErrorDisplay item={item} />
              </>
            );
          })
        ) : error?.length ? (
          <>
            <div className="mt-4" style={{ fontSize: "18px", fontWeight: 500 }}>
              Error occurred in this process. Please, resolve the following
              errors and try again.
              <span className="text-decoration-underline">
                <Link
                  to={`/gst/gstr-one/${clientCode}`}
                  className="go-back-link"
                  style={{ cursor: "pointer" }}
                >
                  {" "}
                  Go Back
                </Link>
              </span>
            </div>

            <div
              className="mt-2 mb-2 error-msg p-2"
              style={{
                border: "1px solid #ba4916",
                backgroundColor: "#fef2ed",
                borderRadius: "6px",
                width: "fit-content",
                margin: "auto",
              }}
            >
              <span className="mr-1">
                <img src={RedErrorIcon} alt="error" />
              </span>
              <span>{error}</span>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  }

  const body = () => {
    return (
      <>
        <div
          className="p-2 m-3"
          style={{
            border: "solid 1px #bfcbe1",
            borderRadius: "5px",
          }}
        >
          <img
            src={isSummaryCollapsed ? CollapseOpen : CollapseClose}
            alt="collapse"
            style={{ cursor: "pointer" }}
            onClick={handleShowSummary}
          />
          Summary
          {isSummaryCollapsed ? (
            <GstrOneAutoFilledTable data={gstin} gst monthData={month} />
          ) : (
            ""
          )}
        </div>

        <div className="steps-container mt-4">
          <div className="step mr-3">
            <div
              className="step-number"
              style={{
                background: step === 0 || step === 1 ? "#dd4433" : "",
                color: step === 0 || step === 1 ? "white" : "",
              }}
            >
              01
            </div>
            <div
              className="step-title"
              style={{
                color: step === 0 || step === 1 ? "#dd4433" : "",
              }}
            >
              Save Invoices to GSTR Portal
            </div>
          </div>
          <div className="step-line"></div>
          <div className="step ml-3 mr-3">
            <div
              className="step-number"
              style={{
                background: step === 2 ? "#dd4433" : "",
                color: step === 2 ? "white" : "",
              }}
            >
              02
            </div>
            <div
              className="step-title"
              style={{
                color: step === 2 ? "#dd4433" : "",
              }}
            >
              Proceed to File
            </div>
          </div>
          <div className="step-line"></div>
          <div className="step ml-3">
            <div
              className="step-number"
              style={{
                background: step === 3 ? "#dd4433" : "",
                color: step === 3 ? "white" : "",
              }}
            >
              03
            </div>
            <div
              className="step-title"
              style={{
                color: step === 3 ? "#dd4433" : "",
              }}
            >
              Complete GSTR-1 Filing
            </div>
          </div>
        </div>

        <div
          className="mr-3 ml-3 mt-5"
          style={{
            minHeight: "70vh",
            border: "solid 1px #bfcbe1",
            backgroundColor: "#f7f8f9",
          }}
        >
          <div className="w-100 d-flex justify-content-center">
            {step === 0 || step === 1 || step === 2 || step === 3 ? (
              <div className="mt-4 asset_details_text_all_user ">
                <span>
                  <img src={WarningIcon} alt="warning" />
                </span>{" "}
                Please, do not perform any other operations during the filing!
              </div>
            ) : (
              ""
            )}
          </div>
          {step === 1 || step === 0 ? (
            <div
              className=" p-4 text-center mt-3"
              style={{ width: "40%", margin: "auto" }}
            >
              <h1>Step 01 : Save Invoices to GSTR Portal</h1>
              <div
                style={{ fontSize: "20px", fontWeight: 500 }}
                className="mt-4"
              >
                {message !== "GSTR-1 data saved Succesfully!" &&
                  `Please wait while we securely save your data on the GSTR Portal. This may take a moment. Thank you for your patience!`}
                {message === "GSTR-1 data saved Succesfully!" &&
                  `Your data has been uploaded successfully. To reset your data, click the reset button or proceed with Proceed to File.`}
              </div>
              <div className="mt-5 d-flex justify-content-center">
                <Progress
                  striped
                  style={{
                    height: "15px",
                    marginRight: "10px",
                    width: "70%",
                    backgroundColor: "#bfcbe1",
                  }}
                  value={progressValue}
                  color={"success"}
                ></Progress>
              </div>
              <div
                style={{ width: "70%", margin: "auto" }}
                className="text-right mt-2 text-success"
              >
                {progressValue} %
              </div>
              {message === "GSTR-1 data saved Succesfully!" &&
              progressValue <= 100 ? (
                <div className="mb-3" style={{ fontSize: "20px" }}>
                  {numberOfInvoices === 0 ? (
                    " No invoice has been uploaded!"
                  ) : (
                    <>
                   <div> {numberOfInvoices} Total invoices.</div>
                   <div> {numberOfUploadInvoices} Invoices uploaded.</div>
                   <div> {numberOfEInvoices} E-Invoices not uploaded.</div>
                    
                    </>
                  )}{" "}
                </div>
              ) : (
                ""
              )}
              <div className="d-flex justify-content-center align-items-center mt-4">
                <button
                  className="ml-3 btn btn-outline-dark"
                  // style={{ border: "1px solid #bfcbe1" }}
                  disabled={
                    (step === 0 && fetching) ||
                    Array.isArray(error) ||
                    fetching ||
                    error ||
                    progressValue < 100
                  }
                  onClick={() => {
                    // handleFileGstOtp();
                    // setStep(2);
                    handleResetProceedFiling();
                  }}
                >
                  Reset Data
                </button>
                <button
                  className="btn btn-primary ml-3"
                  disabled={
                    (step === 0 && fetching) ||
                    Array.isArray(error) ||
                    fetching ||
                    error ||
                    progressValue < 100
                  }
                  onClick={() => {
                    // handleFileGstOtp();
                    setStep(2);
                    handleProceedFiling();
                  }}
                >
                  Proceed to File
                </button>

                {progressValue < 100 ? (
                  ""
                ) : (
                  <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-download-invoice">
                        Download GSTR-1 JSON File
                      </Tooltip>
                    }
                  >
                    <button
                      className="btn form-control d-flex ml-3"
                      style={{
                        border: "1px solid #dd4433",
                        height: "34px",
                        width: "fit-content",
                      }}
                      onClick={() => {
                        handlePrepareDownload();
                      }}
                    >
                      <img src={NewDownloadIconActive} alt="" />
                    </button>
                  </OverlayTrigger>
                )}
              </div>
              {errorShow()}
            </div>
          ) : step === 3 ? (
            <div
              className=" p-4 text-center mt-3"
              style={{ width: "40%", margin: "auto" }}
            >
              <h1>Step 03 : Complete GSTR-1 Filing</h1>
              <div
                style={{ fontSize: "20px", fontWeight: 500 }}
                className="mt-4"
              >
                We have sent OTP on registered number. Please enter OTP below to
                File GSTR-1.
              </div>
              <div className="d-flex justify-content-center mt-3">
                <input
                  type="text"
                  placeholder="Enter OTP here"
                  className="form-control"
                  style={{ width: "290px" }}
                  value={otp}
                  // maxLength={6}
                  disabled={
                    gstFilingFetching ||
                    message?.includes(
                      `You can't send OTP for more than 3 times. Please try after 1 hour!`
                    ) ||
                    message?.includes(`OTP for GSTR-1 not fetched successfully`)
                  }
                  onChange={(e: any) => {
                    const value = e.target.value;
                    // if (/^\d*$/.test(value)) {
                    // only numeric input
                    setOtp(e.target.value);
                    // }
                    // dispatchResetGstFilingMessage();
                  }}
                  onWheel={(event) => event.currentTarget.blur()}
                />
              </div>
              {(seconds !== 0 || minutes !== 0) &&
                message === "EVC OTP Request sent Successfully!" && (
                  <div className="input-length ml-3 d-flex align-items-center justify-content-center mt-3">
                    Resend OTP in {minutes <= 9 ? "0" : ""}
                    {minutes}:{seconds <= 9 ? "0" : ""}
                    {seconds}
                  </div>
                )}
              {seconds === 0 &&
              minutes === 0 &&
              message === "EVC OTP Request sent Successfully!" ? (
                <div className="ml-3 d-flex align-items-center justify-content-center mt-3">
                  <span className="mr-3">Didn’t receive OTP?</span>
                  <span
                    style={{ color: "#dd4433", cursor: "pointer" }}
                    onClick={(e: any) => {
                      setMinutes(1);
                      dispatchResetGstFilingError();
                      dispatchResetGstFilingMessage();
                      handleFileGstOtp();
                    }}
                  >
                    {" "}
                    Resend
                  </span>
                </div>
              ) : (
                ""
              )}
              <button
                className="btn btn-primary text-center"
                style={{ marginTop: "22px" }}
                onClick={() => handleFinalSubmit()}
                //need to uncomment this condition
                disabled={
                  gstFilingFetching ||
                  error ||
                  Array.isArray(error) ||
                  error?.length
                    ? true
                    : false || otp?.length < 1
                }
              >
                Submit
              </button>

              <div className="mt-2">
                {message?.includes(
                  `You can't send OTP for more than 3 times. Please try after 1 hour!`
                ) ? (
                  <small
                    className="text-danger mt-2"
                    style={{ fontSize: "14px" }}
                  >
                    You can't send OTP for more than 3 times. Please try after 1
                    hour!
                  </small>
                ) : message?.includes(
                    `OTP for GSTR-1 not fetched successfully`
                  ) ? (
                  <small
                    className="text-danger mt-2"
                    style={{ fontSize: "14px" }}
                  >
                    OTP for GSTR-1 not fetched successfully
                  </small>
                ) : message?.includes(
                    `OTP for GSTR-1 not verified successfully`
                  ) ? (
                  <small
                    className="text-danger mt-2"
                    style={{ fontSize: "14px" }}
                  >
                    OTP for GSTR-1 not verified successfully
                  </small>
                ) : (
                  ""
                )}
              </div>
              {errorShow()}
            </div>
          ) : step === 4 ? (
            <div
              className=" p-4 text-center mt-3"
              style={{ width: "40%", margin: "auto" }}
            >
              <img src={SuccessFill} alt="success" />
              <h1 className="mt-3">Your GSTR-1 Filing is Successful.</h1>
              <div
                style={{ fontSize: "20px", fontWeight: 500 }}
                className="mt-4"
              >
                Your GSTR-1 has been successfully filed. Kindly{" "}
                <Link
                  to={`/gst/gstr-one/${clientCode}`}
                  className="go-back-link"
                  style={{ cursor: "pointer" }}
                >
                  go back
                </Link>{" "}
                to return to the previous screen. Please ensure to note down
                your ACK number or take a screenshot for future reference.
              </div>

              {gstOneFilingACKNumber ? (
                <div
                  className="mt-4  success-alert"
                  style={{ width: "fit-content", margin: "auto" }}
                >
                  Acknowledgement Number: {gstOneFilingACKNumber}
                </div>
              ) : (
                ""
              )}
            </div>
          ) : (
            <div
              className=" p-4 text-center mt-3"
              style={{ width: "40%", margin: "auto" }}
            >
              <h1>Step 02 : Proceed to File</h1>
              <div
                style={{ fontSize: "20px", fontWeight: 500 }}
                className="mt-4"
              >
                {/* Your OTP is verified successfully, please click on button below
                to file your GSTR-1. */}
                Please complete the GSTR-1 filing with EVC OTP verification by
                clicking the button below.
              </div>

              <button
                className="btn btn-primary mt-4"
                onClick={handleFileGstOtp}
                disabled={
                  fetching || error || Array.isArray(error) || error?.length
                    ? true
                    : false
                }
              >
                File GSTR-1 With EVC OTP
              </button>
              {errorShow()}
            </div>
          )}
        </div>
      </>
    );
  };
  return (
    <div className="new-table-card p-4">
      {body()}
      {handleErrorModal()}
      {error ===
      "Please complete the OTP verification steps to access GST APIs!" ? (
        <ValidateGST
          clientCode={clientCode}
          gstDetails={gstDetails}
          history={history}
        />
      ) : null}
      {gstFetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.gst.gstFilingFetching,
  error: state.gst.gstFilingError,
  gstFilingSuccess: state.gst.gstFilingSuccess,
  success: state.gst.success,
  message: state.gst.gstFilingMessage,
  statusCode: state.gst.gstFilingStatusCode,
  gstFetching: state.gst.fetching,
  gstError: state.gst.error,
  gstOtpVerifyMessage: state.gst.gstOtpVerifyMessage,
  gstOneFilingACKNumber: state.gst.gstOneFilingACKNumber,
  numberOfInvoices: state.gst.numberOfInvoices,
  numberOfUploadInvoices: state.gst.numberOfUploadInvoices,
  numberOfEInvoices: state.gst.numberOfEInvoices,
  gstOneFilingStatus: state.gst.gstOneFilingStatus,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGstrOneDataSave: (data: PostGstrOneSaveDataType) =>
    dispatch(postGstrOneFilingSaveDataAction(data)),
  dispatchGstrOneFilingSendOTP: (data: GstrFilingSendOTPPayload) =>
    dispatch(postGstrOneFilingSendOTPAction(data)),
  dispatchResetGstFilingError: () => dispatch(resetGstFilingError()),
  dispatchResetGstFilingSuccess: () => dispatch(resetGstFilingSuccess()),
  dispatchGstOneProceedFileAction: (data: PostGstrOneProceedType) =>
    dispatch(gstOneProceedFileAction(data)),
  dispatchGstrOneComleteFiling: (data: PostGstrOneCompleteFilingType) =>
    dispatch(postGstrOneCompleteFilingAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetGstModuleError: () => dispatch(resetGstModuleError()),
  dispatchResetGstFilingMessage: () => dispatch(resetGstFilingMessage()),
  dispatchGstrOneResetDataSave: (data: PostGstrOneSaveDataType) =>
    dispatch(postGstrOneFilingResetSaveDataAction(data)),
  dispatchResetGstOtpVerifyMessage: () => dispatch(resetGstOtpVerifyMessage()),
  dispatchResetGstOneFilingACKNumber: () =>
    dispatch(resetGstOneFilingACKNumber()),
  dispatchResetNumberOfInvoices: () => dispatch(resetNumberOfInvoices()),
  dispatchGstOneFilingStatus: (data: GstrOneSatusType) =>
    dispatch(gstOneFilingStatus(data)),
  dispatchResetGstOneFilingStatus: () => dispatch(resetGstOneFilingStatus()),
  dispatchResetGstOneFilingStatusSuccess: () =>
    dispatch(resetGstOneFilingStatusSuccess()),
  dispatchResetGstOneFilingStatusError: () =>
    dispatch(resetGstOneFilingStatusError()),
  dispatchResetGstOneFilingStatusStatusCode: () =>
    dispatch(resetGstOneFilingStatusStatusCode()),
  dispatchResetGstOneFilingStatusMessage: () =>
    dispatch(resetGstOneFilingStatusMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(GstOneFiling);
